(() => {
  if (window.KHFastProductLoaded) return;
  window.KHFastProductLoaded = true;

  let activeController = null;
  const responseCache = new Map();
  const CACHE_LIMIT = 20;
  const REQUEST_TIMEOUT = 8000;

  const installMobileTabStyles = () => {
    if (document.getElementById('kh-fast-mobile-tab-stability')) return;

    const style = document.createElement('style');
    style.id = 'kh-fast-mobile-tab-stability';
    style.textContent = `
      @media (max-width: 599px) {
        .kh-fast-product__tab-list {
          flex-wrap: nowrap;
          align-items: stretch;
          scroll-snap-type: x mandatory !important;
          scroll-padding-inline: 14px;
          overscroll-behavior-x: contain;
          scrollbar-width: none;
        }
        .kh-fast-product__tab-list::-webkit-scrollbar {
          display: none;
        }
        .kh-fast-product__tab-button {
          white-space: nowrap;
          line-height: 1;
          scroll-snap-align: start;
        }
      }
      @media (max-width: 359px) {
        .kh-fast-product__tab-list {
          scroll-padding-inline: 10px;
        }
      }
    `;
    document.head.appendChild(style);
  };

  installMobileTabStyles();

  const installOptionBoxStyles = () => {
    if (document.getElementById('kh-fast-option-box-polish')) return;

    const style = document.createElement('style');
    style.id = 'kh-fast-option-box-polish';
    style.textContent = `
      .kh-fast-product__option-group legend {
        margin-bottom: 10px;
      }
      .kh-fast-product__option-values {
        gap: 9px;
      }
      .kh-fast-product__option {
        max-width: 100%;
        min-height: 46px;
        padding: 10px 14px;
        border-color: #d7d7d7;
        border-radius: 7px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, .03);
        text-align: center;
        line-height: 1.3;
        transition: border-color .15s ease, background .15s ease, color .15s ease, box-shadow .15s ease, transform .15s ease;
      }
      .kh-fast-product__option:hover {
        border-color: #8d8d8d;
        box-shadow: 0 2px 7px rgba(0, 0, 0, .07);
        transform: translateY(-1px);
      }
      .kh-fast-product__option.is-selected {
        border-color: #222;
        color: #fff;
        background: #222;
        box-shadow: 0 2px 7px rgba(0, 0, 0, .12);
      }
      .kh-fast-product__option.is-unavailable:not(.is-selected) {
        border-color: #e2e2e2;
        background-color: #fafafa;
        background-image: linear-gradient(to bottom right, transparent 48%, #d3d3d3 49%, #d3d3d3 51%, transparent 52%);
        box-shadow: none;
      }
      @media (max-width: 599px) {
        .kh-fast-product__option-values {
          gap: 8px;
        }
        .kh-fast-product__option {
          min-height: 46px;
          padding: 10px 12px;
          border-radius: 7px;
        }
      }
    `;
    document.head.appendChild(style);
  };

  installOptionBoxStyles();

  const setLoading = (section, loading) => {
    if (!section) return;
    section.classList.toggle('is-loading', loading);
    const indicator = section.querySelector('[data-kh-loading]');
    if (indicator) indicator.hidden = !loading;
  };

  const cacheResponse = (key, value) => {
    if (responseCache.has(key)) responseCache.delete(key);
    responseCache.set(key, value);

    if (responseCache.size > CACHE_LIMIT) {
      responseCache.delete(responseCache.keys().next().value);
    }
  };

  const updateSection = async (link) => {
    const section = link.closest('[data-kh-fast-product]');
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const destinationUrl = new URL(link.href, window.location.origin);
    const requestUrl = new URL(destinationUrl.href);
    requestUrl.searchParams.set('section_id', sectionId);

    activeController?.abort();
    const controller = new AbortController();
    activeController = controller;
    const timeoutId = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT);

    setLoading(section, true);

    try {
      let responseText = responseCache.get(requestUrl.href);

      if (!responseText) {
        const response = await fetch(requestUrl.href, {
          signal: controller.signal,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'text/html'
          }
        });

        if (!response.ok) {
          throw new Error(`Option request failed with status ${response.status}.`);
        }

        responseText = await response.text();
        cacheResponse(requestUrl.href, responseText);
      }

      if (controller !== activeController) return;

      const parsed = new DOMParser().parseFromString(responseText, 'text/html');
      const incoming = parsed.getElementById(`KHFastProduct-${sectionId}`);

      if (!incoming) {
        throw new Error('The fast product section was not returned.');
      }

      section.replaceWith(incoming);
      window.history.replaceState({}, '', `${destinationUrl.pathname}${destinationUrl.search}${destinationUrl.hash}`);
    } catch (error) {
      if (controller !== activeController) return;

      console.warn('Fast product option update failed; using normal navigation instead.', error);
      window.location.assign(destinationUrl.href);
    } finally {
      window.clearTimeout(timeoutId);
      if (controller === activeController) activeController = null;
    }
  };

  const resetSearchSelectedVariant = () => {
    const currentUrl = new URL(window.location.href);
    const cameFromStoreSearch = currentUrl.searchParams.has('_pos')
      && currentUrl.searchParams.has('_sid')
      && currentUrl.searchParams.has('_ss');

    if (!cameFromStoreSearch || !currentUrl.searchParams.has('variant')) return;

    const section = document.querySelector('[data-kh-fast-product]');
    if (!section) return;

    currentUrl.searchParams.delete('variant');

    const defaultLink = document.createElement('a');
    defaultLink.href = currentUrl.href;
    defaultLink.hidden = true;
    section.appendChild(defaultLink);
    updateSection(defaultLink);
  };

  document.addEventListener('click', (event) => {
    const optionLink = event.target.closest('[data-kh-option-link]');

    if (optionLink) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      updateSection(optionLink);
      return;
    }

    const tabButton = event.target.closest('[data-kh-tab-button]');

    if (tabButton) {
      const tabs = tabButton.closest('[data-kh-tabs]');
      const target = tabButton.dataset.khTabButton;
      if (!tabs || !target) return;

      tabs.querySelectorAll('[data-kh-tab-button]').forEach((button) => {
        const active = button === tabButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });

      tabs.querySelectorAll('[data-kh-tab-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.khTabPanel !== target;
      });

      return;
    }

    const thumbnail = event.target.closest('[data-kh-thumbnail]');
    if (!thumbnail) return;

    const section = thumbnail.closest('[data-kh-fast-product]');
    const mainImage = section?.querySelector('[data-kh-main-image]');
    if (!mainImage) return;

    mainImage.src = thumbnail.dataset.src;
    mainImage.srcset = thumbnail.dataset.srcset || '';
    mainImage.alt = thumbnail.dataset.alt || '';

    section.querySelectorAll('[data-kh-thumbnail]').forEach((button) => {
      button.classList.toggle('is-selected', button === thumbnail);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetSearchSelectedVariant, { once: true });
  } else {
    resetSearchSelectedVariant();
  }
})();
